import { render, staticRenderFns } from "./unit_edit_product.vue?vue&type=template&id=4d57385e&scoped=true&"
import script from "./unit_edit_product.vue?vue&type=script&lang=js&"
export * from "./unit_edit_product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d57385e",
  null
  
)

export default component.exports